<template>
  <ReasonsToLeave @goToConfirm="$emit('goToConfirm')"/>
</template>

<script>
import ReasonsToLeave from "./ReasonsToLeave.vue";

export default {
  name: 'UninstallSurvey',
  components: {
    ReasonsToLeave,
  },
}
</script>
